export { default } from './config-invalid';
